import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const PasswordHelper = styled(Typography)(({ theme }) => ({
  marginTop: '12px',
  color: theme.palette.grey[600]
}))
